export default new class Helpers {
    constructor() {
        this.mobileMinWidth = 768;
    }

    isMobile () {
        if ($(window).width() > this.mobileMinWidth) {
            return false;
        }

        return true;
    }
};



// WEBPACK FOOTER //
// ./src/common/modules/helpers/helpers.js